/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ left: NonNullable<unknown>, total: NonNullable<unknown> }} Price_Page_Pack_LeftInputs */

const en_price_page_pack_left = /** @type {(inputs: Price_Page_Pack_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.left} of ${i?.total} left`)
};

const pl_price_page_pack_left = /** @type {(inputs: Price_Page_Pack_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`zostało ${i?.left} z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{left} of {total} left" |
*
* @param {Price_Page_Pack_LeftInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_pack_left = /** @type {((inputs: Price_Page_Pack_LeftInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Pack_LeftInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_pack_left(inputs)
	return en_price_page_pack_left(inputs)
});